'use client';

import { useState } from 'react';
import { useTourStore } from '@eliadmin/core/src/stores/tours-store';
import { Checkbox } from '@eliadmin/core/src/components/ui/checkbox';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { TourSidebarFilterLabel } from '../tour-sidebar-filter-label';
import { fetchTravelAgencyAttributeValues } from '@eliadmin/core/src/api/travel-agency/travel-agency-api';
import { useQuery } from '@tanstack/react-query';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const TourSidebarFilterLocation = () => {
  const { filter, setFilter } = useTourStore();
  const [showCount, setShowCount] = useState(6);
  const locale = useLocaleStore(state => state.currentLocale);
  const { t } = useTranslations();

  const { data: attributes } = useQuery({
    queryKey: ['travel_agency_attributes_location'],
    queryFn: async () => {
      return await fetchTravelAgencyAttributeValues({ locale, attributeId: 8 }).then(res =>
        res.data.map(item => {
          return { label: item.name, value: item.id.toString() };
        }),
      );
    },
  });

  const handleCheckedChange = (value: string) => {
    const currentLocations = filter.values || [];
    const updatedValues = currentLocations.includes(value)
      ? currentLocations.filter(d => d !== value) // Remove if already checked
      : [...currentLocations, value]; // Add if not checked

    setFilter({
      ...filter,
      values: updatedValues,
    });
  };

  const filteredLocations = attributes || [];

  // Reset showCount if fewer than 6 items
  const displayedLocations = filteredLocations.slice(0, showCount);
  if (filteredLocations.length <= 6 && showCount > 6) {
    setShowCount(6);
  }

  return (
    <div className="text-sm">
      <TourSidebarFilterLabel label={t('text1687')} />
      <div className="mt-4 flex flex-col gap-2">
        {displayedLocations.map(location => (
          <div key={location.value} className="flex items-center gap-2">
            <Checkbox
              id={location.value}
              value={location.value}
              checked={(filter.values || []).includes(location.value)}
              onCheckedChange={() => handleCheckedChange(location.value)}
              className="rounded-[4px]"
            />
            <label htmlFor={location.value} className="cursor-pointer select-none text-gray-800">
              {location.label}
            </label>
          </div>
        ))}
        {filteredLocations.length > showCount && (
          <p
            onClick={() => setShowCount(showCount + 5)}
            className="mt-2 cursor-pointer text-primary"
          >
            + {t('text1856')}
          </p>
        )}
      </div>
    </div>
  );
};
